import React, { useContext, useEffect, useRef, useState } from "react";
import { MTable, Flex, Button, Plus, PencilSimple, TrashSimple, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../contexts/i18nContext";
import { deleteLocationMetadataLh2, editLocationMetadataLh2, getMetadataListLh2, getTenantLocationMetadata, saveLocationMetadataLh2 } from "../../service/business-hierarchy-service";
import "./location-metadata.scss";
import emptyStateImage from "../../assets/images/hierarchy-base/metadata_emptystate.png";
import AddMetadataPopup from "./add-metadata-popup";
import DeleteMetadataPopup from "./delete-metadata-popup";
import EditMetadataPopup from "./edit-metadata-popup";
import useNotification from "../../hooks/useNotification";
import useLoader from "../../hooks/useLoader";

function LocationMetadata(props) {
  const i18n = useContext(I18nContext);
  const { setToastMessage } = useNotification();
  const { loading, setLoading } = useLoader();
  const { node, setModalOpened } = props;
  const [metadataList, setMetadataList] = useState([]);
  const [metadataKeyList, setMetadataKeyList] = useState([]);
  const [metadataKeyListActual, setMetadataKeyListActual] = useState([]);
  const isData = true;
  // const [locationId, setLocationId] = useState(null);
  const locationId = node?.id;
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [metadataToAddObj, setMetadataToAddObj] = useState([]);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [metadataKeyListVisible, setMetadataKeyListVisible] = useState([]);
  const [currentKeyindex, setCurrentKeyindex] = useState(0);
  const [metadataKeyEditVisible, setMetadataKeyEditVisible] = useState(false);
  const [metadataToEditObj, setMetadataToEditObj] = useState({});
  const metadataTodeleteObj = useRef({});
  const oldObject = useRef({});
  const uniqueToAdd = useRef(false);

  const isValid = (previousMetadataProvided) => {
    const regexp1 = /^[a-zA-Z0-9]*$/;
    let isValidBool = true;
    setIsError(false);
    setErrorMessage("");

    previousMetadataProvided.forEach((element) => {
      if (element.key === null || element.key === "") {
        isValidBool = false;
        setIsError(true);
        setErrorMessage(i18n.t("location-metadata-bulk.provide-required-key-msg"));
      } else if (element.key.length > 18) {
        isValidBool = false;
        setIsError(true);
        setErrorMessage(i18n.t("location-metadata-bulk.provide-shorter-key"));
      } else if (!regexp1.test(element.key)) {
        isValidBool = false;
        setToastMessage(i18n.t("location-metadata-bulk.special-characters-not-allowed-msg"), 5000, "negative");
        setErrorMessage(i18n.t("location-metadata-bulk.special-characters-not-allowed-msg"));
        setIsError(true);
      } else if (element.values[0] === undefined || element.values[0].trim() === "") {
        isValidBool = false;
        setIsError(true);
        setErrorMessage(i18n.t("location-metadata-bulk.provide-required-value-msg"));
      }
    });
    return isValidBool;
  };

  const validateEditInfo = (toEditObj) => {
    let isValidBool = false;
    console.log("toeditobj", toEditObj);
    const regexp1 = /^[a-zA-Z0-9]*$/;
    if (toEditObj.key === null || toEditObj.key === "") {
      // setIsError(true);
      setErrorMessage(i18n.t("location-metadata-bulk.provide-required-key-msg"));
    } else if (toEditObj.key?.length > 18) {
      // setIsError(true);
      setErrorMessage(i18n.t("location-metadata-bulk.provide-shorter-key"));
    } else if (!regexp1.test(toEditObj.key)) {
      setErrorMessage(i18n.t("location-metadata-bulk.special-characters-not-allowed-msg"));
      // setIsError(true);
    } else if (toEditObj.values[0] === undefined || toEditObj.values[0].trim() === "") {
      // setIsError(true);
      setErrorMessage(i18n.t("location-metadata-bulk.provide-required-value-msg"));
    } else {
      isValidBool = true;
      setIsError(false);
      setErrorMessage("");
    }
    return isValidBool;
  };

  const prepareMetadataUniquKeyList = (tenantMetaData, locationMetaData) => {
    const uniqueKeys = tenantMetaData.filter((obj) => {
      return locationMetaData.indexOf(obj) === -1;
    });
    setMetadataKeyList([]);
    setMetadataKeyListActual(uniqueKeys);
    uniqueKeys.forEach((key) => {
      const keyItem = { name: key }; // changing key string aray to object with "name" :"keyname" to make filtering work
      setMetadataKeyList((curr) => [...curr, keyItem]);
      // setMetadataKeyListActual((curr) => [...curr, keyItem]);
    });
  };

  const fetchCustomerLocationMetadataListKeys = async () => {
    try {
      const res = await getTenantLocationMetadata(locationId);
      if (res.status && res.data) {
        const data = await res.data;
        const { tenantMetaData, locationMetaData } = data;
        prepareMetadataUniquKeyList(tenantMetaData, locationMetaData);
        // setMetadataKeyList(() => [...metadataKeyListActual]);
      }
    } catch (e) {
      console.error("fetchCustomerLocationMetadataListKeys :: Failed :::", e);
    }
  };

  const filterOutKeys = (fromObject) => {
    // let tempKeyList = [];
    // // remove keys that are already present in metadata list
    // fromObject.forEach((element) => {
    //   tempKeyList = metadataKeyList.filter((e) => e.name !== element.key);
    //   setMetadataKeyList(tempKeyList);
    // });
    console.log(fromObject);
  };

  const fetchMetadataList = async () => {
    try {
      const res = await getMetadataListLh2(locationId);
      if (res.status && res.data) {
        const data = await res.data;
        setMetadataList(() => data.reverse());
        setLoading(false);
        setMetadataKeyList(() => [...metadataKeyListActual]);
        filterOutKeys(metadataList);
      }
    } catch (e) {
      setMetadataList([]);
      console.error("fetchMetadataList :: Failed :::", e);
    }
  };

  const prepareAddMetadata = () => {
    setMetadataKeyList(metadataKeyListActual);
    filterOutKeys(metadataList);

    if (isValid(metadataToAddObj)) {
      filterOutKeys(metadataToAddObj);
      setMetadataToAddObj((prevMetadata) => [...prevMetadata, { key: null, values: [] }]);
    }
  };

  const setUp = () => {
    setMetadataToAddObj([{ key: null, values: [] }]);
    // fetchCustomerLocationMetadataListKeys();
    // fetchMetadataList();
    setCurrentKeyindex(0);
    setMetadataKeyListVisible([]);
    setMetadataKeyEditVisible(false);
  };

  const isValidValue = (valueEntered) => {
    const fvalueEntered = !valueEntered || valueEntered === undefined ? valueEntered : valueEntered.trim();
    if (!fvalueEntered || fvalueEntered === undefined || fvalueEntered.trim() === "") {
      setIsError(true);
      setErrorMessage(i18n.t("location-metadata-bulk.provide-required-key-msg"));
    } else {
      setIsError(false);
      setErrorMessage("");
    }
  };

  // const prepareMetadataKeyList = (keyList) => {
  //   const newMetadataKeyList = [];
  //   const newMetadataKeyListActual = [];

  //   Object.keys(keyList).forEach(function (key) {
  //     console.log(key, keyList[key]);
  //     const keyItem = { name: keyList[key] }; // changing key string array to object with "name" :"keyname" to make filtering work
  //     newMetadataKeyList.push(keyItem);
  //     newMetadataKeyListActual.push(keyItem);
  //   });

  //   setMetadataKeyList(newMetadataKeyList);
  //   setMetadataKeyListActual(newMetadataKeyListActual);
  // };

  const uniqueKeyCheck = () => {
    const keysToAdd = metadataToAddObj.map((ele) => ele.key);
    console.log("Keys to add is ", keysToAdd);
    const unique = Array.from(new Set(keysToAdd)).length === keysToAdd.length;
    console.log("unique check", unique);
    uniqueToAdd.current = unique;
    return unique;
  };

  const hideAddMetadataPopup = () => {
    setShowAddPopup(false);
    setModalOpened(false);
    setMetadataToAddObj([{ key: null, values: [] }]);
    setIsError(false);
    setErrorMessage("");
  };

  const hideEditMetadataPopup = () => {
    setShowEditPopup(false);
    setModalOpened(false);
    setMetadataToEditObj({});
    oldObject.current = {};
    console.log("closing popup", metadataToEditObj);
  };

  const saveMetadata = async () => {
    console.log("saving metadata as ", metadataToAddObj);
    setMetadataKeyListVisible([]);
    if (isValid(metadataToAddObj) && uniqueKeyCheck()) {
      try {
        const response = await saveLocationMetadataLh2(locationId, metadataToAddObj);
        console.log("response is ", response, response.status, response.data);
        if (response.status && response.data.length > 0) {
          setToastMessage(i18n.t("location-metadata-bulk.metadata-saved-success"), 5000, "positive");
          fetchCustomerLocationMetadataListKeys();
          setMetadataList(() => response.data.reverse());
          hideAddMetadataPopup();
          setUp();
        } else {
          console.log("save :: error");
          setToastMessage(i18n.t("location-metadata-bulk.error-on-saving-metadata-msg"), 5000, "negative");
        }
      } catch (error) {
        console.log("save :: error");
        setToastMessage(i18n.t("location-metadata-bulk.error-on-saving-metadata-msg"), 5000, "negative");
      }
    } else {
      setIsError(true);
      setErrorMessage(i18n.t("location-metadata-bulk.provide-required-key-msg"));
      if (!uniqueToAdd.current) {
        setIsError(true);
        setErrorMessage(i18n.t("location-metadata-bulk.enter-unique-values-msg"));
      }
    }
  };

  const editMetadata = async () => {
    console.log("edit metadata as ", metadataToEditObj);
    setMetadataKeyEditVisible(false);
    if (validateEditInfo(metadataToEditObj)) {
      if (oldObject.current.key === metadataToEditObj?.key) {
        try {
          const response = await editLocationMetadataLh2(locationId, [metadataToEditObj]);
          if (response.status && response.data.length > 0) {
            setToastMessage(i18n.t("location-metadata-bulk.metadata-edited-successfully-msg"), 5000, "positive");
            hideEditMetadataPopup();
            fetchMetadataList();
            fetchCustomerLocationMetadataListKeys();
          } else {
            console.log("edit :: error");
            setToastMessage(i18n.t("location-metadata-bulk.error-on-editing-location-msg"), 5000, "negative");
          }
        } catch (error) {
          console.log("edit :: error");
          setToastMessage(i18n.t("location-metadata-bulk.error-on-editing-location-msg"), 5000, "negative");
        }
      } else {
        // delete old and add new case;
        try {
          const deleteResponse = await deleteLocationMetadataLh2(locationId, oldObject.current);
          if (deleteResponse.status) {
            setMetadataToAddObj([metadataToEditObj]);
            const tempMetadataToAddObj = [metadataToEditObj];
            const saveResponse = await saveLocationMetadataLh2(locationId, tempMetadataToAddObj);
            if (saveResponse.status && saveResponse.data.length > 0) {
              setToastMessage(i18n.t("location-metadata-bulk.metadata-updated-successfully"), 5000, "positive");
              fetchMetadataList();
              fetchCustomerLocationMetadataListKeys();
              hideAddMetadataPopup();
              setShowEditPopup(false);
              setModalOpened(false);
            } else {
              console.log("save :: error");
              setToastMessage(i18n.t("location-metadata-bulk.error-on-edit-location-metadata-msg"), 5000, "negative");
            }
          } else {
            setToastMessage(i18n.t("location-metadata-bulk.error-on-edit-location-metadata-msg"), 5000, "negative");
          }
        } catch (error) {
          console.log("delete :: error");
          setToastMessage(i18n.t("location-metadata-bulk.error-on-edit-location-metadata-msg"), 5000, "negative");
        }
      }
    } else {
      setIsError(true);
      setErrorMessage(i18n.t("location-metadata-bulk.enter-required-value-msg"));
      setToastMessage(i18n.t("location-metadata-bulk.error-on-edit-location-metadata-msg"), 5000, "negative");
    }
    setMetadataToAddObj([]);
  };

  const deleteMetadata = async () => {
    console.log("delete metadata from list", metadataTodeleteObj.current);
    try {
      const response = await deleteLocationMetadataLh2(locationId, metadataTodeleteObj.current);
      if (response.status) {
        setToastMessage(i18n.t("location-metadata-bulk.metadata-deleted-successfully-msg"), 5000, "positive");
        setMetadataList(response.data.reverse());
      } else {
        console.log("delete :: error");
        setToastMessage(i18n.t("location-metadata-bulk.error-on-deleting-location-metadata-msg"), 5000, "negative");
      }
    } catch (error) {
      console.log("delete :: error");
      // Handle your error here...
    }
    setShowDeletePopup(false);
    setModalOpened(false);
  };

  // const selectMetaKey = (key, index) => {
  //   const newMetadataToAddObj = [...metadataToAddObj];
  //   newMetadataToAddObj[index].key = {};
  //   newMetadataToAddObj[index].key = key;
  //   newMetadataToAddObj[index].values = [];
  //   setMetadataToAddObj(newMetadataToAddObj);
  // };

  const onMetadataKeySelection = (event, index) => {
    const newMetadataToAddObj = [...metadataToAddObj];
    newMetadataToAddObj[index] = {};
    newMetadataToAddObj[index].key = event.target.value;
    newMetadataToAddObj[index].values = [];
    setMetadataToAddObj(newMetadataToAddObj);
    setMetadataKeyList(metadataKeyListActual);
    filterOutKeys(newMetadataToAddObj);
  };

  const onMetadataKeyForEditSelection = (event) => {
    setMetadataToEditObj((prev) => ({ ...prev, key: event.target.value }));
  };

  const showEditMetadataPopup = (index) => {
    setShowEditPopup(true);
    setModalOpened(true);
    oldObject.current = {};
    setMetadataToEditObj({
      key: metadataList[index].key,
      values: metadataList[index].value
    });
    oldObject.current.key = metadataList[index].key;
    oldObject.current.values = metadataList[index].value;
    console.log("metadataToEditObj", metadataToEditObj);
    setIsError(false);
    setErrorMessage("");
  };

  const showAddMetadataPopup = () => {
    setShowAddPopup(true);
    setModalOpened(true);
    // setIsError(true);
    setErrorMessage("");
    setMetadataKeyList(metadataKeyListActual);
    filterOutKeys(metadataList);
  };

  const showDeleteMetadataPopup = (index) => {
    setShowDeletePopup(true);
    setModalOpened(true);
    metadataTodeleteObj.current = metadataList[index];
  };

  const cancelDeleteMetadataPopup = () => {
    setShowDeletePopup(false);
    setModalOpened(false);
    metadataTodeleteObj.current = {};
  };

  const removeFromToAddObj = (index) => {
    if (metadataToAddObj[index].key !== undefined && metadataToAddObj[index].key !== null) setMetadataKeyList((prevState) => [...prevState, metadataToAddObj[index].key]);

    const newMetadataToAddObj = [...metadataToAddObj];
    newMetadataToAddObj.splice(index, 1);
    setMetadataToAddObj(newMetadataToAddObj);

    if (newMetadataToAddObj.length === 0) {
      setMetadataToAddObj([{ key: null, values: [] }]);
      // setIsError(true);
      setErrorMessage("");
    }
    console.log("spliced array", newMetadataToAddObj);
    isValid(newMetadataToAddObj);
  };

  // const toggleDropDown = (listType, index) => {
  //   if (index !== currentKeyindex) {
  //     setMetadataKeyListVisible((prevState) => {
  //       const newState = [...prevState];
  //       newState[currentKeyindex] = false;
  //       return newState;
  //     });
  //   }

  //   if (listType === "metaKey") {
  //     setMetadataKeyListVisible((prevState) => {
  //       const newState = [...prevState];
  //       newState[index] = !prevState[index];
  //       return newState;
  //     });
  //   }

  //   setCurrentKeyindex(index);
  // };

  // const toggleEditDropDown = (listType) => {
  //   if (listType === "metaKey") {
  //     setMetadataKeyEditVisible((prevState) => !prevState);
  //   }
  // };

  const checkValidAdd = () => {
    return isValid(metadataToAddObj);
  };

  // const checkValidEdit = () => {
  //   return validateEditInfo(metadataToEditObj);
  // };

  const getActionsCellValue = ({ row }) => {
    return (
      <div>
        {node && node.data && node.data.access === "Full" && (
          <Button.Group>
            <Button
              icon={<PencilSimple size={16} weight="bold" />}
              disabled={node.data && node.data.access !== "Full"}
              kind="tertiary"
              className="lh20-metadata-edit-button"
              onClick={() => showEditMetadataPopup(row.index)}
            />

            <Button
              disabled={node.data && node.data.access !== "Full"}
              icon={<TrashSimple size={16} weight="bold" />}
              kind="tertiary"
              className="lh20-metadata-delete-button"
              onClick={() => showDeleteMetadataPopup(row.index)}
            />
          </Button.Group>
        )}
      </div>
    );
  };

  useEffect(() => {
    // activeNode(selectedNode);
    // setLocationId(node.id);
    // locationId = node?.id;
    setUp();
    console.log(`${metadataKeyList} : ${metadataKeyEditVisible} : ${metadataKeyListVisible} : ${currentKeyindex}`);
    return () => {
      console.log("Destroy");
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    if (locationId) fetchCustomerLocationMetadataListKeys();
    if (locationId) fetchMetadataList();

    return () => {
      console.log("Destroy");
    };
  }, [locationId]);

  return (
    <div className="loc-metadata-tab">
      {metadataList.length > 0 && isData && (
        <Flex direction="vertical" gap={16} style={{ marginLeft: "16px" }}>
          <Flex className="table-header-text" justify="flex-end" align="center">
            <Button icon={<Plus size={16} weight="bold" />} kind="secondary" onClick={showAddMetadataPopup} id="metadata-add-button">
              {i18n.t("location-metadata-bulk.add-metadata-text")}
            </Button>
          </Flex>
          <MTable
            columns={[
              {
                accessorKey: "key",
                header: i18n.t("location-metadata-bulk.metadata-key-text")
              },
              {
                accessorKey: "value",
                header: i18n.t("location-metadata-bulk.value-text")
              },
              {
                accessorKey: "number",
                cell: getActionsCellValue,
                header: i18n.t("location-metadata-bulk.actions-text")
              }
            ]}
            data={metadataList}
          />
        </Flex>
      )}
      {metadataList.length === 0 && !loading && (
        <Flex className="team-empty-business">
          <Flex direction="vertical" justify="center" style={{ marginLeft: "16px" }}>
            <div className="title">
              <Text size="p1" weight="bold">
                {i18n.t("location-metadata-bulk.no-metadata-configured")}
              </Text>
            </div>
            <div className="desc">
              <Text size="p2" weight="regular" color="light">
                {i18n.t("location-metadata-bulk.click-to-add-metadata")}
              </Text>
            </div>
            <div>
              <Button onClick={showAddMetadataPopup} disabled={node?.data && node?.data.access !== "Full"} kind="secondary" icon={<Plus size={16} weight="bold" />} id="metadata-add-button">
                {i18n.t("location-metadata-bulk.add-metadata-text")}
              </Button>
            </div>
          </Flex>
          <div>
            <div>
              <img alt="no metadata" className="team-empty-img" src={emptyStateImage} />
            </div>
          </div>
        </Flex>
      )}

      <DeleteMetadataPopup showDeletePopup={showDeletePopup} cancelDelete={cancelDeleteMetadataPopup} deleteLocation={deleteMetadata} />

      {showEditPopup && (
        <EditMetadataPopup
          showEditPopup={showEditPopup}
          cancelEdit={hideEditMetadataPopup}
          editMetadata={editMetadata}
          isError={isError}
          errorMessage={errorMessage}
          metadataToEditObj={metadataToEditObj}
          isValidValue={isValidValue}
          onMetadataKeyForEditSelection={onMetadataKeyForEditSelection}
          setMetadataToEditObj={setMetadataToEditObj}
          metadataKeyList={metadataKeyListActual}
        />
      )}

      {showAddPopup && (
        <AddMetadataPopup
          showAddPopup={showAddPopup}
          cancelAdd={hideAddMetadataPopup}
          isError={isError}
          errorMessage={errorMessage}
          metadataToAddObj={metadataToAddObj}
          metadataKeyList={metadataKeyListActual}
          onMetadataKeySelection={onMetadataKeySelection}
          setMetadataToAddObj={setMetadataToAddObj}
          isValid={isValid}
          isValidValue={isValidValue}
          checkValidAdd={checkValidAdd}
          removeFromToAddObj={removeFromToAddObj}
          prepareAddMetadata={prepareAddMetadata}
          saveMetadata={saveMetadata}
        />
      )}
    </div>
  );
}

export default LocationMetadata;
